import axios from 'axios'
import { Post, Category, PostsResponse } from '../types'

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://baochinhphu-backend-development.xox-labs-server.workers.dev/api'

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Posts API (public endpoints only)
export const postsAPI = {
  getAll: async (params?: any): Promise<PostsResponse> => {
    const response = await api.get('/posts', { params })
    return response.data
  },
  
  getById: async (id: string): Promise<{ post: Post }> => {
    const response = await api.get(`/posts/${id}`)
    return response.data
  },
  
  getByCategory: async (categorySlug: string, params?: any): Promise<PostsResponse> => {
    const response = await api.get('/posts', { 
      params: { category: categorySlug, ...params }
    })
    return response.data
  },
  
  search: async (query: string, params?: any): Promise<PostsResponse> => {
    const response = await api.get('/posts', { 
      params: { search: query, ...params }
    })
    return response.data
  },
  
  getFeatured: async (limit = 5): Promise<PostsResponse> => {
    const response = await api.get('/posts', { 
      params: { limit, status: 'published', is_featured: 'true' }
    })
    return response.data
  },

  getMostViewed: async (limit = 10): Promise<PostsResponse> => {
    const response = await api.get('/posts/most-viewed', { 
      params: { limit }
    })
    return response.data
  },

  getByMediaType: async (mediaType: 'video' | 'podcast', limit = 10): Promise<PostsResponse> => {
    const response = await api.get('/posts', { 
      params: { media_type: mediaType, limit, status: 'published' }
    })
    return response.data
  },
}

// Categories API (public endpoints only)
export const categoriesAPI = {
  getAll: async (): Promise<{ categories: Category[] }> => {
    const response = await api.get('/categories')
    return response.data
  },
  
  getById: async (id: string): Promise<{ category: Category }> => {
    const response = await api.get(`/categories/${id}`)
    return response.data
  },
}

export default api